import { Fail } from './fail';

export class JsonParseFail extends Fail {
  _message = 'Failed to parse response from server';
}
